import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://899b0e068f69b44164431f796020f1cd@o4511065861652480.ingest.de.sentry.io/4511065948618832",
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  environment: "production"
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
